var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-radio-group',{model:{value:(
      _vm.menuSetting.orderDescription.targetDomesticImportedCarClassification
        .domesticImportedCarClassification
    ),callback:function ($$v) {_vm.$set(_vm.menuSetting.orderDescription.targetDomesticImportedCarClassification
        , "domesticImportedCarClassification", $$v)},expression:"\n      menuSetting.orderDescription.targetDomesticImportedCarClassification\n        .domesticImportedCarClassification\n    "}},[_c('v-radio',{attrs:{"label":"国産車","value":"domestic"}}),_c('v-radio',{attrs:{"label":"輸入車","value":"imported"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }